<template>
  <CompTopFilter />
</template>

<script>
import CompTopFilter from "./components/molecules/top-filter/index.vue";

export default {
  components: {
    CompTopFilter,
  },
  async created() {
    if (!this.$store.getters.isLoggedIn) {
      await this.authenticate();
    }

    this.fetchCities();
  },
  methods: {
    authenticate: async function () {
      await this.$store
        .dispatch("authenticate", {})
        .then((result) => {
          const data = get(result, "data");
          if (!data) {
            this.$store.commit("setIsErrorServer", true);
          }
        })
        .catch((e) => {
          this.$store.commit("setIsErrorServer", true);
        });
    },
    fetchCities() {
      this.$store.dispatch("getCities");
    },
  },
};
</script>
